import {
    createAsyncThunk,
    createSlice,
    isAnyOf,
    PayloadAction,
} from '@reduxjs/toolkit';
import DemographicService from '../services/DemographicService';
import IBaseState from '../../types/IBaseState';
import { LOGOUT } from '../../constants/actions/auth.constants';

const NAME = 'Demographics';

const getDemographics = createAsyncThunk(
    `${NAME}/getDemographics`,
    DemographicService.getData,
);
const postAnswer = createAsyncThunk(
    `${NAME}/postAnswer`,
    DemographicService.postAnswer,
);

interface State extends IBaseState<any[]> {
    isOpen: boolean;
}

const initialState: State = {
    data: [],
    loading: false,
    isOpen: false,
};

const slice = createSlice({
    name: NAME,
    initialState,
    reducers: {
        toggleDemographics: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
            return state;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getDemographics.fulfilled, (state: State, action) => {
            state.loading = false;
            state.data = action.payload.data;
        });

        builder.addCase(postAnswer.fulfilled, (state: State) => {
            state.loading = false;
            state.isOpen = false;
        });

        builder.addCase(LOGOUT, () => initialState);

        builder.addMatcher(
            isAnyOf(getDemographics.pending, postAnswer.pending),
            (state: State) => {
                state.loading = true;
            },
        );

        builder.addMatcher(
            isAnyOf(getDemographics.rejected, postAnswer.rejected),
            (state: State) => {
                state.loading = false;
            },
        );
    },
});

const DemographicActions = {
    getDemographics,
    postAnswer,
    ...slice.actions,
};

export default DemographicActions;
export const DemographicReducer = slice.reducer;
